import React, { Component } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import firebase from 'firebase';

class Contribution extends Component {

  constructor() {
    super();
    this.state = {
      question: '',
      correctAnswer: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.rootRef = firebase.database().ref();
    this.contributionRef = this.rootRef.child('Contribution');
  }

  handleChange(event) {
    const value = event.target.value
    const name = event.target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    console.log(this.state.question);
    event.preventDefault();
  }

  render() {
    return (
      <div className="Contribution">
        <p id="welcomeTitle">Contribute Your Questions!</p>
        <form onSubmit={this.handleSubmit}>
          <label>
            <p id="formTitle">Question</p>
            <textarea id="contributionText"
                      defaultValue={this.state.question} 
                      onChange={this.handleChange}
                      placeholder="Type your question here..." required></textarea>
          </label>
          <label>
            <p id="formTitle">Correct Answer</p>
            <textarea id="contributionText"
                      defaultValue={this.state.correctAnswer} 
                      onChange={this.handleChange}
                      placeholder="Type the correct answer here..." required></textarea>
          </label>
          <br/>  
          <br/>            
          <input id="submitBtn" type="submit" value="Submit" />
        </form>
        <button id="startBtn"><Link to="/" id="homeLink">Back to Home</Link></button>
      </div>
    );
  }
}  

export default Contribution;
